import { useCallback } from 'react'

export function useOnConfirm(onConfirm: () => void, onClose?: () => void) {
  return useCallback(() => {
    onConfirm()
    onClose?.()
  }, [onConfirm, onClose])
}
